import _ from 'underscore';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'view/base';
import View_Menu from 'page/project/menu';
import View_Project_Edit from 'view/project/edit';
import View_Workflow_Edit from 'view/workflow_edit';
import View_Automation_Edit from 'view/project/settings_automation';
import View_AI_Assist_Edit from 'view/project/settings_ai';
import View_Email_Edit from 'view/project/settings_email';
import View_Privacy_Edit from 'view/project/settings_privacy';
import View_Advanced_Edit from 'view/project/settings_advanced';

export default View.extend({
    views: {
        menu: {},
        edit: {}
    },

    event_handlers: {
        onNavigate: function(menu) {
            if (menu === 'portal' && !Cache.portal.findWhere({project_id: this.model.id})) {
                Modals.activatePortal();
                return;
            }

            this.views.edit.remove();

            this.views.edit = this.getEditView(menu);
            this.views.edit.render().$el.appendTo(this.$el);
        }
    },

    getEditView: function(menu) {
        switch (menu) {
            case 'general':
                return new View_Project_Edit({model: this.model});
            case 'workflow':
                return new View_Workflow_Edit({model: this.model, is_modal: false});
            case 'automation':
                return new View_Automation_Edit({model: this.model});
            case 'email_forwarding':
                return new View_Email_Edit({model: this.model});
            case 'ai_assist':
                return new View_AI_Assist_Edit({model: this.model});
            case 'privacy':
                return new View_Privacy_Edit({model: this.model});
            case 'advanced':
                return new View_Advanced_Edit({model: this.model});
        }
    },

    initialize: function(options) {
        this.default_menu = options && options.menu ? options.menu : 'general';

        this.views.menu = new View_Menu({
            model: this.model,
            menu: this.default_menu
        });
        this.views.edit = this.getEditView(this.default_menu);

        this.listenTo(this.views.menu, 'navigate', this.event_handlers.onNavigate.bind(this));
    },

    render: function() {
        this.views.menu.render().$el.appendTo(this.$el);
        this.views.edit.render().$el.appendTo(this.$el);

        return this;
    }
});